import { render, staticRenderFns } from "./AddExchangeCourse.vue?vue&type=template&id=13315fb0&"
import script from "./AddExchangeCourse.vue?vue&type=script&lang=js&"
export * from "./AddExchangeCourse.vue?vue&type=script&lang=js&"
import style0 from "./AddExchangeCourse.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports